export const SITE_URL = "https://giinovacoes.com.br";
export const SITE_NAME = "Gi Inovações";
export const SOCIAL_IMAGE = `${SITE_URL}/assets/hero/mural.webp`;

export const ROUTE_SEO = {
  "/": {
    title: ["Gi Inovações — Matrizes, EVA e Gi Reboot®", "Gi Inovações — Matrices, EVA y Gi Reboot®"],
    description: [
      "Gi Inovações: matrizes, solados e compostos em EVA e E-TPU Gi Reboot®. Engenharia, conforto e sustentabilidade para calçados.",
      "Gi Inovações: matrices, suelas y compuestos de EVA y E-TPU Gi Reboot®. Ingeniería, confort y sostenibilidad para calzado.",
    ],
    label: ["Início", "Inicio"],
  },
  "/empresa": {
    title: ["Empresa e história | Gi Inovações", "Empresa e historia | Gi Inovações"],
    description: [
      "Conheça a história, a estrutura industrial e o compromisso da Gi Inovações com tecnologia, qualidade e sustentabilidade.",
      "Conozca la historia, la estructura industrial y el compromiso de Gi Inovações con la tecnología, la calidad y la sostenibilidad.",
    ],
    label: ["Empresa", "Empresa"],
  },
  "/gi-reboot": {
    title: ["Gi Reboot® — Solados em E-TPU | Gi Inovações", "Gi Reboot® — Suelas de E-TPU | Gi Inovações"],
    description: [
      "Gi Reboot® é a tecnologia em E-TPU da Gi Inovações para solados leves, resistentes, confortáveis e com alto retorno de energia.",
      "Gi Reboot® es la tecnología E-TPU de Gi Inovações para suelas ligeras, resistentes, cómodas y con alto retorno de energía.",
    ],
    label: ["Gi Reboot®", "Gi Reboot®"],
  },
  "/eva": {
    title: ["Solados, chinelos e compostos em EVA | Gi Inovações", "Suelas, chanclas y compuestos de EVA | Gi Inovações"],
    description: [
      "Soluções industriais em EVA para solados, chinelos e compostos personalizados, com desempenho técnico e opções sustentáveis.",
      "Soluciones industriales de EVA para suelas, chanclas y compuestos personalizados, con rendimiento técnico y opciones sostenibles.",
    ],
    label: ["Soluções em EVA", "Soluciones de EVA"],
  },
  "/matrizes": {
    title: ["Matrizes para calçados e usinagem 5 eixos | Gi Inovações", "Matrices para calzado y mecanizado de 5 ejes | Gi Inovações"],
    description: [
      "Desenvolvimento de matrizes para calçados com tecnologia 3D, usinagem 5 eixos, precisão e suporte técnico especializado.",
      "Desarrollo de matrices para calzado con tecnología 3D, mecanizado de 5 ejes, precisión y soporte técnico especializado.",
    ],
    label: ["Matrizes", "Matrices"],
  },
  "/contato": {
    title: ["Contato | Gi Inovações", "Contacto | Gi Inovações"],
    description: [
      "Fale com a Gi Inovações sobre matrizes, solados, compostos em EVA, Gi Reboot®, projetos personalizados ou oportunidades profissionais.",
      "Hable con Gi Inovações sobre matrices, suelas, compuestos de EVA, Gi Reboot®, proyectos personalizados u oportunidades profesionales.",
    ],
    label: ["Contato", "Contacto"],
  },
  "/artigos": {
    title: ["Artigos técnicos sobre calçados | Gi Inovações", "Artículos técnicos sobre calzado | Gi Inovações"],
    description: [
      "Conteúdos técnicos sobre matrizes, solados em EVA, E-TPU, compostos, desenvolvimento de produto e inovação para calçados.",
      "Contenidos técnicos sobre matrices, suelas de EVA, E-TPU, compuestos, desarrollo de producto e innovación para calzado.",
    ],
    label: ["Artigos", "Artículos"],
  },
};

export const absoluteUrl = (value) => {
  if (!value) return SOCIAL_IMAGE;
  if (/^https?:\/\//i.test(value)) return value;
  return `${SITE_URL}${value.startsWith("/") ? value : `/${value}`}`;
};

export const canonicalUrl = (pathname) => {
  const cleanPath = pathname === "/" ? "" : pathname.replace(/\/$/, "");
  return `${SITE_URL}${cleanPath}`;
};